import styled from "styled-components";

export const LayOutContainer = styled.div`
  margin: auto;
  min-height: calc(100vh - 8.6rem);
  padding-bottom: 10rem;
`;
